const Running = () => (
  <svg focusable={false} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'>
    <g fill='none' fillRule='evenodd'>
      <circle cx={24} cy={24} r={20} fill='#7C53A5' />
      <g fill='#FFF' fillRule='nonzero' transform='translate(12 11)'>
        <path d='M8.579 14.676a1.49 1.49 0 0 1-.491-.508c-.421 1.104-.959 2.452-1.263 3.115-.795.022-2.572-.155-4.046-.398-.631-.088-1.216.31-1.31.883a1.088 1.088 0 0 0 .936 1.237c.047 0 1.24.2 2.479.31.678.066 1.263.11 1.754.11 1.052 0 1.684-.199 2.011-.75.234-.398.819-1.812 1.333-3.115-.327-.2-.678-.442-1.076-.685-.163-.089-.257-.155-.327-.199z' />
        <path d='M22.114 11.053c-.119-.435-.619-.696-1.095-.587-.239.065-1.858.457-2.835.718-.048-.087-.071-.196-.095-.283-.381-1.023-.977-2.59-2.454-3.133-.333-.131-1.096-.436-1.62-.631-2.096-.827-5.74.065-6.217.239-.262.087-.81.283-2.382 3.133-.214.414-.048.893.405 1.11.12.065.262.087.405.087a.94.94 0 0 0 .81-.457c.476-.914 1.19-2.045 1.5-2.372.358-.108 1.215-.283 2.168-.391-1.024 1.284-1.93 3.329-2.096 4.047-.214 1.045.262 1.393.453 1.502.38.239 3.93 2.393 4.43 2.916-.143.74-.833 2.872-1.477 4.656-.19.566.12 1.154.739 1.35.119.043.238.043.357.043.477 0 .93-.283 1.096-.718.62-1.697 1.667-4.7 1.62-5.527-.024-.827-.858-1.545-2.668-2.699.595-1.305 1.548-3.198 2.453-4.178.334.457.572 1.088.739 1.567.262.696.452 1.197.953 1.436.143.066.285.087.452.087.12 0 .238-.021.358-.065.404-.13 2.215-.587 3.334-.849.5-.108.787-.565.667-1z' />
        <ellipse
          cx='15.627'
          cy='4.71'
          rx='2.487'
          ry='2.3'
          transform='rotate(-66.814 15.627 4.71)'
        />
      </g>
    </g>
  </svg>
);

export default Running;
